import { apiLink } from '../../constants/env';
import axiosInstance from '../AxiosInstance';

const apiEconomia = {
    getTotal: async () => {
        const URL = `${apiLink()}api/economia/compressores`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();
            })
    },
}

export default apiEconomia; 